import React, { useEffect, useState, useCallback, useRef } from 'react';
import Masonry from 'react-masonry-css';
import styles from './MobileScrollResults.module.css';
import * as ccUtils from '../CC/utils';
import { useCCContext } from '../CC/CCContext';
import { getImages } from '../Result/getImages';
import ImageWithFallback from '../GenericComponents/ImageWithFallback';
import { use } from 'i18next';

const IconItem = ({ record, index }: { record: any; index: any }) => {
  
  let imageUrl = ""; //todo: noimage
  const allImages = getImages(record);
  if ((allImages as any)["mobilelist"]?.length > 0) {
    imageUrl = (allImages as any)["mobilelist"][0]?.url;
  }
  console.log(imageUrl);

  const title = record?.data?.Record?.Title;
  const formattedTitle = Array.isArray(title)
    ? title.map((t: any, idx: number) => <div key={idx}>{t.Title}</div>)
    : typeof title === 'object'
      ? title.Title
      : title ?? 'No title';
  const recordNumber = record?.metadata?.recordnumber;
  const invNo = record?.data?.Record?.ObjectNumber;

  return (
    <div key={`scroll_icons_${recordNumber}`} className={styles.iconItem}>
      <div className={styles.iconItemImage}>
        {<ImageWithFallback src={imageUrl} alt="Image" maxWidth="240" maxHeight="120" placeholder="ccImageProxy.ashx?filename=noimage/pas-dimage-white.png&width=240&height=120" />}
      </div>
      <div className={styles.iconItemTitle}>{formattedTitle}</div>
    </div>
  );
};

type MobileScrollResults = {
  mainY: number;
  setAndKeepMainY: (newMainY: number, prevMainY: number) => void;
  selectedRecord: any | null;
  setSelectedRecord: React.Dispatch<React.SetStateAction<any | null>>;
};

const MobileScrollResults: React.FC<MobileScrollResults> = ({ mainY, setAndKeepMainY, selectedRecord, setSelectedRecord }) => {
  const nextStartIndex = useRef(1);
  const instanceRef = useRef({});
  const [items, setItems] = useState<any[]>([]);
  const { cc, sort } = useCCContext();
  const noMoreRecords = useRef<boolean>(false);
  const [localCc, setLocalCc] = useState(cc);
  const [localSort, setLocalSort] = useState(sort);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const lastItemRef = useRef<HTMLDivElement | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(async () => {
    console.log(nextStartIndex.current);
    if (nextStartIndex.current > 500 || isLoading || noMoreRecords.current) {
      return;
    }
    setIsLoading(true);
    const startIndex = nextStartIndex.current;
    const endIndex = startIndex + 29;
    const postData = ccUtils.generatePayload(localCc, localSort, startIndex, endIndex);
    console.log(postData);
    try {
      const data = await ccUtils.postWithCache(process.env.REACT_APP_BASE_URL as string, postData, instanceRef);
      let records = data.records.record;
      records = Array.isArray(records) ? records : [records];
      console.log(records);
      console.log(records.length);
      if (records && records.length > 0 && records[0]) {
        setItems((prevItems) => [...prevItems, ...records]);
        nextStartIndex.current += 30;
      } else {
        noMoreRecords.current = true;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  }, [localCc, localSort]);

  /*
  useEffect(() => {
    fetchData(); // Initial fetch
  }, []);
  */

  useEffect(() => {
    nextStartIndex.current = 1;
    setItems([]);
    noMoreRecords.current=false;
    fetchData();
  }, [localCc]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !isLoading) {
          fetchData();
        }
      },
      { threshold: 0.1 }
    );

    observerRef.current = observer;

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [localCc]);

  useEffect(() => {
    const handleResize = () => {
      if (lastItemRef.current && observerRef.current) {
        observerRef.current.unobserve(lastItemRef.current);
        observerRef.current.observe(lastItemRef.current);
      }
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, [items]);

  useEffect(() => {
    setLocalCc(cc);
  }, [cc]);

  const selectRecord = (record: any) => {
    setSelectedRecord(record)
    setAndKeepMainY(-300, -200);
  };

  const handleLinkClick = (event: React.MouseEvent, record: any) => {
    selectRecord(record);
  };

  const breakpointColumnsObj = {
    default: 5,
    1280: 4,
    1050: 3,
    820: 2,
    590: 1,
  };

  return (
    <div>
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {items.map((record, index) => (
          <div key={index} ref={index === items.length - 1 ? lastItemRef : null} onClick={(event) => handleLinkClick(event, record)}>
            <IconItem record={record} index={index} />
          </div>
        ))}
      </Masonry>
      {isLoading && <div>Loading...</div>}
    </div>
  );
};

export default MobileScrollResults;